/**
 * This is a utility that establishes a tabindex loop around elements
 * you want to cycle through with the TAB key.
 *
 * Add `tabindex=0` attribute to elements that aren't focused by default
 * (ie. not inputs) if you want them to be included in the loop.
 *
 * @usage
 *      <!-- Other content above this -->
 *      <div class="js-focus-guard-start" tabindex="0"></div>
 *          <input class="js-focus-first" type="text" />
 *          <input type="text" />
 *          <input type="text" />
 *          <input type="text" />
 *          <input class="js-focus-last" type="text" />
 *      <div class="js-focus-guard-end" tabindex="0"></div>
 *      <!-- Other content below this -->
 */
export default (element = document) => {
    const startGuards = Array.from(element.querySelectorAll('.js-focus-guard-start'));

    startGuards.forEach((startGuard) => {
        const container = startGuard.parentNode;
        const endGuard = container.querySelector('.js-focus-guard-end');
        const lastField = container.querySelector('.js-focus-last');
        const firstField = container.querySelector('.js-focus-first');

        startGuard.addEventListener('focus', () => lastField.focus());
        endGuard.addEventListener('focus', () => firstField.focus());
    });
};



// WEBPACK FOOTER //
// ./app/scripts/components/focus-guard.js